<template>
  <div>
    <el-select v-model="paras.status" placeholder="请选择" @change="handleSearch">
      <el-option v-for="n in travelStatus" :key="n.key" :label="n.label" :value="n.value"></el-option>
    </el-select>
    <template>
      <!-- 列表 -->
      <el-table :data="tableData" style="width: 100%;margin-top:15px">
        <el-table-column label="用户类型">
          <template slot-scope="scope">{{scope.row.memberLevelId === null ?'普通账户' :'会员账户'}}</template>
        </el-table-column>
        <el-table-column label="用户头像">
          <template width="100" slot-scope="scope">
            <img style="width:40px;height:40px;border:none;" :src="scope.row.icon" />
          </template>
        </el-table-column>
        <el-table-column label="用户名" prop="username" :formatter="username"></el-table-column>
        <el-table-column label="昵称" prop="nickname" :formatter="nickname"></el-table-column>
        <el-table-column label="手机号" prop="phone" :formatter="phone"></el-table-column>
        <el-table-column label="积分" prop="integration"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope" v-if="scope.row.memberLevelId">
            <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 查看会员账户信息 -->
    <div>
      <el-dialog title="企业账号信息" :visible.sync="detaildialogVisible" width="50%">
        <!-- 详情内容 -->
        <el-descriptions class="margin-top" :column="2" border>
          <el-descriptions-item>
            <template slot="label">企业名称</template>
            {{detailData.enterpriseName}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">联系人</template>
            {{detailData.name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">手机</template>
            {{detailData.phone}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">邮箱</template>
            {{detailData.mail}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">公司地址</template>
            {{detailData.address}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">信用代码证</template>
            {{detailData.creditCode}}
          </el-descriptions-item>
        </el-descriptions>

        <span slot="footer" class="dialog-footer">
          <el-button @click="detaildialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="detaildialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div style="margin-top:30px ;text-align:center; ">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="handelCurrentChange"
        :current-page="currentpageIndex"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { queryUserMsg, queryEnterpriseCertification } from '../../api'
export default {
  data () {
    return {
      paras: {
        status: 1,
      },
      travelStatus: [ //  状态列表
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '会员账户'
        },
        {
          value: 2,
          label: '普通账户'
        },
      ],
      currentpageIndex: 1,
      currentpageSize: 10,
      memberType: 1,
      tableData: [],
      total: 0,
      detaildialogVisible: false,
      detailData: []
    }
  },
  methods: {
    queryEnterpriseCertification (id) {
      let para = new URLSearchParams()
      para.append('userId', id)
      queryEnterpriseCertification(para).then(data => {
        console.log('查询企业认证账号信息', data);
        if (data.code === 10000) {
          if (data.data[0]) {
            this.detaildialogVisible = true
            this.detailData = data.data[0]
          } else {
            this.$message({
              message: '没有认证信息',
              type: 'error'
            })
          }
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    //查看
    handleDetail (index, row) {
      console.log(index, row);

      //查询企业信息
      this.queryEnterpriseCertification(row.id)
    },
    username (row, column) {
      if (row.username === null) {
        return '/'
      } else {
        return row.username
      }
    },
    nickname (row, column) {
      if (row.nickname === null) {
        return '/'
      } else {
        return row.nickname
      }
    },

    phone (row, column) {
      if (row.phone == null || row.phone == '' || row.phone == ' ') {
        return '/'
      } else {
        return row.phone
      }
    },
    handleSearch (index) {
      console.log(index);
      this.status = index
      this.memberType = index
      this.currentpageIndex = 1
      this.queryUserMessage()
    },
    handelCurrentChange (i) { // 分页
      console.log(i);
      this.currentpageIndex = i
      this.queryUserMessage()
    },
    queryUserMessage () {
      let para = new URLSearchParams()
      para.append('pageIndex', this.currentpageIndex)
      para.append('pageSize', this.currentpageSize)
      if (this.memberType !== 0) {
        para.append('memberType', this.memberType)
      }
      //请求接口
      queryUserMsg(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.tableData = data.data.rows
          this.total = data.data.total
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    }


  },
  mounted () {
    //请求用户数据
    this.queryUserMessage()

  }
}

</script>
<style lang="stylus" scoped>
.comond_btn {
  display: flex;
  justify-content: center;

  button {
    background-color: #0a3d5f;
    color: #fff;
  }
}
</style>
